import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ServerConfigData,
  ServerConfigService,
} from '@ipg/ngx-frontend-toolset';

@Injectable({
  providedIn: 'root',
})
export class ImageCompressionService {
  private readonly _serverConfig =
    inject<ServerConfigService<ServerConfigData>>(ServerConfigService);

  private readonly _fileAllowedTypes = this._serverConfig.data.fileAllowedTypes.filter(
    (value) => value.mimeType.startsWith('image/')
  );

  private readonly _maxCompressionSizeMap = new Map(
    this._fileAllowedTypes.map((c) => [c.mimeType, c.compressionSize])
  );

  compress(file: File): Observable<File> {
    const compressionSize = this._maxCompressionSizeMap.get(file.type);

    return new Observable((observer) => {
      if (!file.type.startsWith('image/')) {
        observer.next(file);
        observer.complete();

        return;
      }

      const worker = new Worker(new URL('./image-compression.worker', import.meta.url));

      worker.onmessage = ({ data }: MessageEvent<File>) => {
        observer.next(data);
        observer.complete();

        worker.terminate();
      };

      worker.onerror = (error) => {
        observer.error(error);

        worker.terminate();
      };

      worker.postMessage({
        file,
        config: {
          compressionSize,
        },
      });
    });
  }
}
